export default __webpack_public_path__ + "static/media/Placement-Stats-20-21.6b87495c.pdf";